module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_danone_02.5ded35ea.jpg";